<button
  type="button"
  mat-icon-button
  [focus-outline]="-2"
  id="playlistOptionsButton-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}"
  [attr.aria-label]="'Options menu for ' + displayName"
  [matMenuTriggerFor]="playlistOptions"
>
  <mat-icon aria-hidden="true" svgIcon="more-horizontal"></mat-icon>
</button>
<mat-menu
  #playlistOptions="matMenu"
  id="playlistOptions-{{ key }}-{{ isUserComponents ? 'user' : 'base' }}"
  xPosition="before"
  role="menu"
  tabindex="-1"
  aria-labelledby="playlistOptionsButton-{{ key }}-{{
    isUserComponents ? 'user' : 'base'
  }}"
>
  @if (!componentRequiresUpgrade) {
    <button
      class="playlist-item-rename"
      tabindex="-1"
      mat-menu-item
      role="menuitem"
      (click)="onRename()"
    >
      <mat-icon aria-hidden="true" svgIcon="pencil"></mat-icon>
      <span>Edit Label</span>
    </button>
  }
  @if (!isDataComponent) {
    <div>
      @if (isUserComponents && showDuplicateAction) {
        <button
          class="playlist-item-duplicate"
          tabindex="-1"
          mat-menu-item
          role="menuitem"
          (click)="onDuplicate()"
        >
          <mat-icon aria-hidden="true" svgIcon="duplicate"></mat-icon>
          <span>Duplicate</span>
        </button>
        <button
          class="playlist-item-delete"
          tabindex="-1"
          mat-menu-item
          role="menuitem"
          (click)="onRemove()"
        >
          <mat-icon aria-hidden="true" svgIcon="trash"></mat-icon>
          <span>Delete</span>
        </button>
      }
      <!-- Last action, matching the order of the inline toolbar. -->
      @if (
        showVisibilityToggle && (!componentRequiresUpgrade || !isUserComponents)
      ) {
        <button
          class="playlist-item-hide"
          tabindex="-1"
          mat-menu-item
          role="menuitem"
          (click)="onVisibilityChange(!componentVisibility)"
        >
          <mat-icon
            aria-hidden="true"
            [svgIcon]="componentVisibility ? 'eye-close' : 'eye-open'"
          ></mat-icon>
          <span>{{ componentVisibility ? 'Hide' : 'Show' }}</span>
        </button>
      }
    </div>
  }
</mat-menu>
